import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { crmApi, type Customer } from '../../api/crm';

export function SupportCenterPage() {
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    void crmApi.listCustomers().then(setCustomers);
  }, []);

  async function openCase(id: string) {
    await crmApi.createCase(id, 'Order delivery delay');
    setMsg('Support case created');
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/customers" className="text-sm text-slate-600 hover:underline">← CRM hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Support center</h1>
      {msg && <p className="mt-2 text-sm text-green-700">{msg}</p>}
      <ul className="mt-4 space-y-2">
        {customers.map((c) => (
          <li key={c.id}>
            <button type="button" onClick={() => void openCase(c.id)}
              className="rounded border px-3 py-2 text-sm">Open case — {c.customer_code}</button>
          </li>
        ))}
      </ul>
    </div>
  );
}
